jQuery(function($) {

    clearCacheIfExternalReferrer();

    var SharedSession = {


        /**
         * Gets information about the user's cart.
         * If successful the retrieved data is passed through to the success callback.
         */
        cart:  function($item, options) {
            var params = $.extend({
                action: "cart",
                currencySymbol: "£",
                success: function(response, params) {

                    $item.html("<span class=\"quantity\">"+ response.itemQuantity +"</span> <span class=\"value\">"+ params.currencySymbol + response.balance +"<span>");

                    $("body").addClass(function() {
                        var classes = [
                            "shared-session__active",
                            "shared-session__basket"
                        ];

                        if (response.balance !== "00.00") {
                            classes.push("shared-session__basket-content");
                        } else {
                            classes.push("shared-session__basket-empty");
                        }


                        return classes.join(" ");
                    });
                }
            }, this._defaults, options);

            var response = this._request(params);
        },

        /**
         * Gets information about the current user's session.
         * If successful the retrieved data is passed through to the success callback.
         */
        session: function($item, options) {
            var params = $.extend({
                action: "session",
                success: function(response, params) {

                    $("body").addClass(function() {
                        var classes = [
                            "shared-session__active",
                            "shared-session__user"
                        ];

                        if (response.sessions.ElectronicAddress) {
                            classes.push("shared-session__user-logged-in");
                            $item.html("<span class=\"status\">"+ response.sessions.ElectronicAddress +"<span>");

                        } else {
                            classes.push("shared-session__user-logged-out");
                            $item.html("<span class=\"status\">Log In<span>");
                        }

                        return classes.join(" ");
                    });

                }
            }, this._defaults, options);


            var response = this._request(params);
        },
        /**
         * Gets information about the current user's name.
         * If successful the retrieved data is passed through to the success callback.
         */
        constituent: function($item, options) {
            var params = $.extend({
                action: "constituent",
                success: function(response, params) {
                    $("body").addClass(function() {
                        var classes = [
                            "shared-session__active",
                            "shared-session__user"
                        ];

                        if (response.constituent.FirstName) {
                            classes.push("shared-session__user-logged-in");
                            $item.html("<span class=\"status\">"+ response.constituent.FirstName +"<span>");

                        } else {
                            classes.push("shared-session__user-logged-out");
                            $item.html("<span class=\"status\">Log In<span>");
                        }

                        return classes.join(" ");
                    });
                }
            }, this._defaults, options);

            var response = this._request(params);
        },

        _callback: function(params, response) {
            if (typeof params.callback === "function") {
                params.callback(response);

            } else {
                console.warn("Shared sessions callback must be of type function", params.callback);
            }
        },

        _defaults: {
            cache: 30,
            debug: false,
            data: {},
            error: function(response, params) {
            },
            complete: function(response, params) {
            },
            timeout: function(response, params) {
            },
        },

        _debug: function(title, response, params) {
            console.log(
                title,
                {
                    response: response,
                    params: params,
                }
            );
        },

        _request: function(params) {
            var _this = this;
            var localSharedSession = getFromLocalStorage(params.action);
            if (localSharedSession) {
                params.success(localSharedSession, params);
                return;
            }
            $.ajax({
                url: window.sharedSessions.ajaxURL,
                data: {
                    action: "sharedsession",
                    method: params.action,
                    data: params.data,
                    cache: params.cache,
                },
                dataType: "json",
                method: "POST",
                error: function(response) {
                    if (params.debug === true) {
                        _this._debug("Shared sessions error", response, params);
                    }
                    params.error(response, params);
                },
                success: function(response) {
                    if (params.debug === true) {
                        _this._debug("Shared sessions success", response, params);
                    }
                    params.success(response, params);
                    setLocalStorage(params.action, response, params.cache)
                },
                complete: function(response) {
                    if (params.debug === true) {
                        _this._debug("Shared sessions complete", response, params);
                    }
                    params.complete(response, params);
                },
                timeout: function(response) {
                    if (params.debug === true) {
                        _this._debug("Shared sessions timeout", response, params);
                    }
                    params.timeout(response, params);
                },
            });

            return;
        }

    };

    /**
     * Register the jQuery plugin.
     * @return this jQuery object
     */
    $.fn.sharedSession = function(method, options) {
        method = method || "session";
        method = method.toLowerCase();

        if (method === "cart") {
            SharedSession.cart(this, options);

        } else if (method === "session") {
            SharedSession.session(this, options);

        } else if (method === "constituent") {
            SharedSession.constituent(this, options);

        } else {
            console.warn("Shared sessions method not recognised", method);
        }

        return this;
    };

    /**
     * Look for local storage based on `key` and check it hasn't expired
     * @param {string} key
     * @return {mixed}
     */
    function getFromLocalStorage(key)
    {
        let data = localStorage.getItem('shared-session-' + key);
        if (data) {
            let now = new Date().getTime().toString();
            data = JSON.parse(data);
            // No expiry was set, so return the value
            if (!data.expire && data.value) {
                return data.value;
            }
            // Check the data hasn't expired
            if (data.expire && data.expire > now && data.value) {
                return data.value;
            }
            localStorage.removeItem('shared-session-' + key);
        }
        return false;
    }

    /**
     * Set local storage `value` based on `key` with an expiry time
     * @param {string} key
     * @param {mixed} value
     * @param {int} expires
     * @return {mixed}
     */
    function setLocalStorage(key, value, expires = 30)
    {
        let expire = new Date();
        expire.setMinutes(expire.getMinutes() + expires);
        let data = {
            value: value,
            expire: expire.getTime().toString()
        };
        localStorage.setItem('shared-session-' + key, JSON.stringify(data));
    }

    /**
     * Was the referrer from the same domain or an external subdomain or site?
     * @returns bool
     */
    function isExternalReferrer()
    {
        if (document.referrer === "") {
            return true;
        }

        const referrerUrl = new URL(document.referrer);
        const currentUrl = new URL(window.location.href);

        return referrerUrl.origin !== currentUrl.origin;
    }

    /**
     * Clear the localStorage for all shared sessions if isExternalReferrer
     */
    function clearCacheIfExternalReferrer()
    {
        if (isExternalReferrer()) {
            ['cart', 'session', 'constituent'].forEach((key) => {
                localStorage.removeItem('shared-session-' + key);
            })
        }
    }

});
